module.exports = __webpack_public_path__ + "static/intro-img-0b0e0c4bdc4c1d0ffb3108c38167213f.svg";